import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import Calendar from './pages/Calendar';
import Notebook from './pages/Notebook';
import Dashboard from './pages/Dashboard';
import AdminPanel from './pages/AdminPanel';
import Login from './pages/Login';
import IDE from './pages/IDE';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Check for existing auth token
        const token = localStorage.getItem('authToken');
        if (token) {
            // Validate token with backend (simplified for now)
            setIsAuthenticated(true);
            // In production, fetch user details from API
            setUser({ name: 'Demo User', email: 'demo@neuais.com', role: 'admin' });
        }
    }, []);

    const handleLogin = (userData, token) => {
        localStorage.setItem('authToken', token);
        setUser(userData);
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        setUser(null);
        setIsAuthenticated(false);
    };

    return (
        <Router>
            {isAuthenticated && <Navbar user={user} onLogout={handleLogout} />}
            <Routes>
                <Route
                    path="/login"
                    element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/dashboard" />}
                />
                <Route
                    path="/"
                    element={<Homepage isAuthenticated={isAuthenticated} />}
                />
                <Route
                    path="/calendar"
                    element={isAuthenticated ? <Calendar user={user} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/notebook/:sessionId?"
                    element={isAuthenticated ? <Notebook user={user} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/ide"
                    element={isAuthenticated ? <IDE user={user} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/dashboard"
                    element={isAuthenticated ? <Dashboard user={user} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/admin"
                    element={isAuthenticated && user?.role === 'admin' ? <AdminPanel /> : <Navigate to="/dashboard" />}
                />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
